import { render, staticRenderFns } from "./GoodsIssue.vue?vue&type=template&id=540b9297"
import script from "./GoodsIssue.vue?vue&type=script&lang=js"
export * from "./GoodsIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports